import { FC } from "react";
import Drawer from "react-modern-drawer";
import { IconButton, IconButtonSize } from "shared/components";
import { TimeLine } from "shared/components/TimeLine";
import { XClose } from "untitledui-js-base";
import { LogDescription } from "./LogDescription";
import { AudiLog } from "views/rent-reporting-id/types";
import { Loader } from "shared/components/Loader";
import { useMedia } from "shared/providers";

type Props = {
  opened: boolean;
  onClose: () => void;
  acitvityLogs: AudiLog[];
  isLoading?: boolean;
  isError?: boolean;
  residentName?: string;
};

export const ActivityLogDrawer: FC<Props> = ({
  opened,
  onClose,
  acitvityLogs,
  isLoading,
  isError,
  residentName
}) => {
  const { isMobile } = useMedia();

  return (
    <Drawer
      className="rounded-l-lg"
      direction="right"
      size={isMobile ? 360 : 480}
      open={opened}
      onClose={onClose}
    >
      <div className="flex h-screen flex-col">
        <div className="py-4 pl-6 pr-2 flex justify-between items-center border-b border-alpha-80">
          <h2 className="text-content-1000 font-bold text-xl">Activity log</h2>
          <IconButton
            Icon={XClose}
            borderLess
            size={IconButtonSize.SM}
            onClick={onClose}
            className="-translate-x-2"
          />
        </div>
        {isLoading ? (
          <div className="flex items-center justify-center flex-grow">
            <Loader />
          </div>
        ) : isError ? (
          <div className="flex items-center justify-center flex-grow">
            <h1 className="text-xl font-medium text-content-1000">
              Error loading logs
            </h1>
          </div>
        ) : (
          <div className="px-10 overflow-y-auto flex-grow mb-4">
            <TimeLine wrapperClassName="!border-solid border-alpha-100 w-full">
              {acitvityLogs.length
                ? acitvityLogs.map((log, index) => (
                    <LogDescription
                      key={log.id}
                      log={log}
                      residentName={residentName}
                      isLast={index === acitvityLogs.length - 1}
                    />
                  ))
                : null}
            </TimeLine>
          </div>
        )}
      </div>
    </Drawer>
  );
};
